import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import HindustanTimes from "@/assets/icons/news_channel/hindustan-times.png";
import IndianExpress from "@/assets/icons/news_channel/indian-express.png";
import NDTV from "@/assets/icons/news_channel/ndtv.png";
import TheHindu from "@/assets/icons/news_channel/the-hindu.png";
import TOI from "@/assets/icons/news_channel/toi.png";
import ANI from "@/assets/icons/news_channel/ani.png";

export default function Media() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    arrows: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const mediaImages = [
    {
      src: HindustanTimes,
      alt: "HindustanTimes",
    },
    {
      src: IndianExpress,
      alt: "IndianExpress",
    },
    {
      src: NDTV,
      alt: "NDTV",
    },
    {
      src: TheHindu,
      alt: "TheHindu",
    },
    {
      src: TOI,
      alt: "TOI",
    },
    // {
    //   src: ANI,
    //   alt: "ANI",
    // },
  ];

  return (
    <div className="relative bg-cover bg-center" style={{}}>
      <div className="mx-auto">
        <Slider {...settings}>
          {mediaImages.map((image, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center"
            >
              <div className="h-8 flex flex-col items-center justify-center">
                <img
                  src={image.src}
                  alt={image.alt}
                  className={`${image.alt === "NDTV" ? "max-h-3" : "max-h-8 px-2"}`}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
